import state from './moduleCampaignSenderEmailState'
import actions from './moduleCampaignSenderEmailActions'
import getters from './moduleCampaignSenderEmailGetters'
import mutations from './moduleCampaignSenderEmailMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
